export default "__VITE_ASSET__af360ab1__"